(() => {
  const qs = (s, root=document) => root.querySelector(s);
  const qsa = (s, root=document) => [...root.querySelectorAll(s)];

  const menuToggle = qs('[data-menu-toggle]');
  const mobileMenu = qs('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    const closeMenu = () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('is-open');
    };
    menuToggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      if (open) closeMenu();
      else { menuToggle.setAttribute('aria-expanded', 'true'); mobileMenu.classList.add('is-open'); }
    });
    document.addEventListener('pointerdown', (event) => {
      if (mobileMenu.classList.contains('is-open') && !mobileMenu.contains(event.target) && !menuToggle.contains(event.target)) closeMenu();
    });
    window.addEventListener('scroll', closeMenu, {passive:true});
    window.addEventListener('resize', closeMenu);
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-revealed'); }), {threshold:.08});
    qsa('.hb-reveal,.hb-page-card,.hb-shop-card,.hb-how-card').forEach(el => io.observe(el));
  }

  const singleQty = qs('#hb-single-quantity');
  if (singleQty) {
    qs('[data-single-minus]')?.addEventListener('click', () => { singleQty.value = Math.max(1, Number(singleQty.value || 1) - 1); });
    qs('[data-single-plus]')?.addEventListener('click', () => { singleQty.value = Number(singleQty.value || 1) + 1; });
  }


  // Einzelprodukt: Shopify-Variantenbild und Preis sofort aktualisieren.
  const variantSelect = qs('#hb-product-variant');
  const productPrice = qs('#hb-product-price');
  const productMainImage = qs('#hb-product-main-image');
  const productSubmit = qs('#hb-product-submit');
  if (variantSelect) {
    const variantsEl = qs('#hb-product-variants');
    let variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch(e) {}
    const updateVariant = () => {
      const id = String(variantSelect.value);
      const option = variantSelect.options[variantSelect.selectedIndex];
      const variant = variants.find(v => String(v.id) === id);
      if (!variant) return;
      if (productPrice && variant.price != null) {
        productPrice.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency: window.Hausbox?.currency || 'EUR'}).format(Number(variant.price)/100);
      }
      const image = option?.dataset.image || variant.image;
      if (productMainImage && image) productMainImage.src = image;
      if (productSubmit) {
        productSubmit.disabled = !variant.available;
        productSubmit.textContent = variant.available ? 'In den Warenkorb →' : 'Nicht verfügbar';
      }
    };
    variantSelect.addEventListener('change', updateVariant);
    updateVariant();
  }

  qsa('[data-gallery-image]').forEach(btn => btn.addEventListener('click', () => {
    const main = qs('#hb-product-main-image');
    if (!main || !btn.dataset.galleryImage) return;
    main.src = btn.dataset.galleryImage;
    qsa('[data-gallery-image]').forEach(x => x.classList.remove('is-active'));
    btn.classList.add('is-active');
  }));


  // Warenkorb: einzelne Position löschen und Hausbox auf Monatslieferung umstellen.
  const cartForm = qs('#cart');
  if (cartForm) {
    qsa('[data-remove-item]', cartForm).forEach(btn => {
      btn.addEventListener('click', () => {
        const article = btn.closest('.hb-cart-item');
        const input = article?.querySelector('input[name="updates[]"]');
        if (input) {
          input.value = '0';
          cartForm.submit();
        }
      });
    });

    qsa('[data-subscribe-box]', cartForm).forEach(btn => {
      btn.addEventListener('click', async () => {
        const planId = btn.dataset.sellingPlanId;
        const lineKey = btn.dataset.lineKey;
        const variantId = btn.dataset.variantId;
        if (!planId) {
          const t=qs('#hb-toast');
          if(t){t.textContent='Für „Monatlich liefern“ muss im Shopify-Admin ein Abo-Plan für die Hausbox aktiviert sein.';t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),3200);}
          return;
        }
        btn.disabled=true;
        btn.dataset.oldText=btn.textContent;
        btn.textContent='Wird umgestellt …';
        try {
          const cart = await fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json());
          const line = cart.items.find(i=>i.key===lineKey);
          if(!line) throw new Error('line');
          const addResponse = await fetch(`${window.Hausbox.routes.cartAdd}.js`,{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({
              items:[{
                id:Number(variantId),
                quantity:line.quantity,
                selling_plan:Number(planId),
                properties:line.properties || {}
              }]
            })
          });
          if(!addResponse.ok) throw new Error('add');
          const removeResponse = await fetch(`${window.Hausbox.routes.cartChange}.js`,{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({id:lineKey,quantity:0})
          });
          if(!removeResponse.ok) throw new Error('remove');
          window.location.reload();
        } catch(e) {
          btn.disabled=false;
          btn.textContent=btn.dataset.oldText||'Monatlich liefern ↻';
          const t=qs('#hb-toast');
          if(t){t.textContent='Die Monatslieferung konnte nicht aktiviert werden.';t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),2500);}
        }
      });
    });
  }



    if (cartForm) {
      qsa('[data-subscribe-cart]', cartForm).forEach(btn => {
        btn.addEventListener('click', async () => {
          const planId = btn.dataset.sellingPlanId;
          const lineKey = btn.dataset.lineKey;
          const variantId = btn.dataset.variantId;
          if (!planId) {
            const t=qs('#hb-toast');
            if(t){t.textContent='Für „Monatlich liefern“ muss im Shopify-Admin ein Abo-Plan für die Hausbox aktiviert sein.';t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),3200);}
            return;
          }
          btn.disabled=true; btn.dataset.oldText=btn.textContent; btn.textContent='Wird umgestellt …';
          try {
            const cart = await fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json());
            const line = cart.items.find(i=>i.key===lineKey);
            if(!line) throw new Error('line');
            const addResponse = await fetch(`${window.Hausbox.routes.cartAdd}.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:line.quantity,selling_plan:Number(planId),properties:line.properties||{}}]})});
            if(!addResponse.ok) throw new Error('add');
            const removeResponse = await fetch(`${window.Hausbox.routes.cartChange}.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:lineKey,quantity:0})});
            if(!removeResponse.ok) throw new Error('remove');
            window.location.reload();
          } catch(e) {
            btn.disabled=false; btn.textContent=btn.dataset.oldText||'Monatlich liefern ↻';
            const t=qs('#hb-toast');
            if(t){t.textContent='Die Monatslieferung konnte nicht aktiviert werden.';t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),2500);}
          }
        });
      });
    }

  // Einzelprodukt: zuverlässiger Ajax-Warenkorb für echte Shopify-Produkte.
  const productForm = qs('#hb-product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = qs('#hb-product-submit', productForm);
      const variantField = qs('[name="id"]', productForm);
      const qtyField = qs('[name="quantity"]', productForm);
      const variantId = variantField ? variantField.value : '';
      const quantity = Math.max(1, Number(qtyField?.value || 1));
      if (!variantId) return;
      const variant = (() => {
        try { return JSON.parse(qs('#hb-product-variants')?.textContent || '[]').find(v => String(v.id) === String(variantId)); }
        catch(e) { return null; }
      })();
      if (variant && variant.available === false) return;
      if (button) { button.disabled = true; button.dataset.oldText = button.textContent; button.textContent = 'Wird hinzugefügt …'; }
      try {
        const response = await fetch(`${window.Hausbox.routes.cartAdd}.js`, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(variantId),quantity}]})
        });
        if (!response.ok) throw new Error('add');
        window.location.href = window.Hausbox.routes.cart;
      } catch (e) {
        const t=qs('#hb-toast');
        if(t){t.textContent='Das Produkt konnte nicht hinzugefügt werden.';t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),2500);}
        if(button){button.disabled=false;button.textContent=button.dataset.oldText||'In den Warenkorb →';}
      }
    });
  }


  // Einzelprodukte: direkt aus der Übersicht in den Warenkorb (+ / −), ohne die Produktseite öffnen zu müssen.
  qsa('[data-quick-product]').forEach(card => {
    const variantId = card.dataset.quickVariantId;
    const plus = qs('[data-quick-plus]', card);
    const minus = qs('[data-quick-minus]', card);
    const qtyEl = qs('[data-quick-qty]', card);
    let busy = false;
    const syncQty = async () => {
      try {
        const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r=>r.json());
        const line = cart.items.find(item => String(item.variant_id) === String(variantId));
        const qty = line ? Number(line.quantity) : 0;
        if(qtyEl) qtyEl.textContent = qty;
        if(minus) minus.disabled = busy || qty <= 0;
        if(plus) plus.disabled = busy;
      } catch(e) {}
    };
    const changeQty = async (delta) => {
      if(busy) return;
      busy=true; if(plus) plus.disabled=true; if(minus) minus.disabled=true;
      try {
        const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r=>r.json());
        const line = cart.items.find(item => String(item.variant_id) === String(variantId));
        const current = line ? Number(line.quantity) : 0;
        const next = Math.max(0, current + delta);
        let response;
        if(line) {
          response = await fetch(`${window.Hausbox.routes.cartChange}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.key,quantity:next})});
        } else if(next > 0) {
          response = await fetch(`${window.Hausbox.routes.cartAdd}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:next}]})});
        }
        if(!response || !response.ok) throw new Error('cart');
        const updated = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r=>r.json());
        const updatedLine = updated.items.find(item => String(item.variant_id) === String(variantId));
        if(qtyEl) qtyEl.textContent = updatedLine ? updatedLine.quantity : 0;
        const count = qs('#hb-cart-count'); if(count) count.textContent = updated.item_count;
      } catch(e) {
        const t=qs('#hb-toast');
        if(t){t.textContent='Das Produkt konnte nicht aktualisiert werden.';t.classList.add('is-on');setTimeout(()=>t.classList.remove('is-on'),2200);}
      } finally {
        busy=false; syncQty();
      }
    };
    plus?.addEventListener('click', e => {e.preventDefault();e.stopPropagation(); if(card.dataset.quickAvailable === 'false'){return;} changeQty(1);});
    minus?.addEventListener('click', e => {e.preventDefault();e.stopPropagation();changeQty(-1);});
    syncQty();
  });

  // Einzelprodukte: Suche und Kategorie greifen sauber ineinander. Ein Kategorienwechsel leert die Suche.
  const shopSearch = qs('#hb-shop-search');
  const shopClear = qs('#hb-shop-clear-search');
  const shopHint = qs('#hb-shop-search-hint');
  const shopNoResults = qs('#hb-shop-no-results');
  const shopCards = qsa('[data-shop-category-item]');
  let shopCategory = 'all';
  const filterShopProducts = () => {
    const term = (shopSearch?.value || '').trim().toLocaleLowerCase('de-DE');
    let visible = 0;
    shopCards.forEach(card => {
      const categoryMatch = shopCategory === 'all' || card.dataset.shopCategoryItem === shopCategory;
      const text = (card.querySelector('.hb-shop-card-copy')?.textContent || '') + ' ' + (card.querySelector('a')?.getAttribute('href') || '');
      const searchMatch = !term || text.toLocaleLowerCase('de-DE').includes(term);
      card.hidden = !(categoryMatch && searchMatch);
      if (!card.hidden) visible++;
    });
    if (shopClear) shopClear.hidden = !term;
    if (shopNoResults) shopNoResults.hidden = visible > 0;
    if (shopHint) shopHint.textContent = term ? `${visible} ${visible === 1 ? 'Produkt gefunden' : 'Produkte gefunden'}${visible ? ' · in allen Kategorien' : ' · Suchbegriff prüfen'}` : 'Finde einzelne Produkte schnell über die Suche.';
  };
  qsa('[data-shop-category]').forEach(tab=>tab.addEventListener('click',()=>{
    shopCategory = tab.dataset.shopCategory || 'all';
    if (shopSearch) shopSearch.value = '';
    qsa('[data-shop-category]').forEach(x=>{x.classList.toggle('is-active', x === tab); x.setAttribute('aria-pressed', x === tab ? 'true' : 'false');});
    filterShopProducts();
  }));
  shopSearch?.addEventListener('input', filterShopProducts);
  shopClear?.addEventListener('click',()=>{ if(shopSearch){shopSearch.value='';shopSearch.focus();} filterShopProducts(); });
  if (shopCards.length) filterShopProducts();

  // Box ändern: dieselben Produktkarten, Kategorien und globale Suche wie im Haupt-Builder.
  const changeForm = qs('#hb-box-change-form');
  if (changeForm) {
    const cards = qsa('[data-change-product]', changeForm);
    const search = qs('#hb-change-search', changeForm);
    const clear = qs('#hb-change-clear', changeForm);
    const total = qs('#hb-change-total', changeForm);
    const summary = qs('#hb-change-summary', changeForm);
    const bodyField = qs('#hb-change-email-body', changeForm);
    const categoryButtons = qsa('[data-change-category]', changeForm);
    const selectedCount = qs('#hb-change-selected-count', changeForm);
    const searchHint = qs('#hb-change-search-hint', changeForm);
    const sizeSelect = qs('#hb-change-box-size', changeForm);
    const sizeHint = qs('#hb-change-size-hint', changeForm);
    const changeSubmit = qs('.hb-change-submit', changeForm);
    const sizeLimits = {basic:5,family:8,deluxe:12,premium:16};
    let activeCategory = 'all';
    const getLimit = () => sizeLimits[sizeSelect?.value] || 0;
    const getTotalSelected = () => cards.reduce((sum, card) => sum + Math.max(0, Number(card.dataset.changeQty || 0)), 0);
    const updateSelection = () => {
      let count = 0;
      let remaining = getLimit();
      const selected = [];
      cards.forEach(card => {
        const requestedQty = Math.max(0, Number(card.dataset.changeQty || 0));
        const maxQty = Math.max(1, Number(card.dataset.maxQty || 2));
        const qty = Math.min(requestedQty, remaining, maxQty);
        card.dataset.changeQty = String(qty);
        remaining -= qty;
        count += qty;
        const title = card.querySelector('.hb-product-copy strong')?.textContent?.trim() || 'Produkt';
        if (qty > 0) selected.push(`${title} × ${qty}`);
        const minus = card.querySelector('[data-change-minus]');
        const countEl = card.querySelector('[data-change-count]');
        const plus = card.querySelector('[data-change-plus]');
        if (countEl) countEl.textContent = qty;
        if (minus) minus.disabled = qty <= 0;
        if (plus) plus.disabled = !getLimit() || count >= getLimit() || qty >= maxQty || plus.dataset.changeUnavailable === 'true';
        card.dataset.qty = qty;
        card.classList.toggle('is-selected', qty > 0);
        const removeButton = card.querySelector('[data-change-remove]');
        if (removeButton) removeButton.hidden = qty <= 0;
      });
      cards.forEach(card => {
        const plus = card.querySelector('[data-change-plus]');
        const qty = Number(card.dataset.changeQty || 0);
        const maxQty = Math.max(1, Number(card.dataset.maxQty || 2));
        if (plus) plus.disabled = !getLimit() || count >= getLimit() || qty >= maxQty || plus.dataset.changeUnavailable === 'true';
      });
      if (total) total.textContent = count;
      if (selectedCount) selectedCount.textContent = count;
      if (changeSubmit) changeSubmit.disabled = !(getLimit() && count === getLimit());
      if (sizeHint) sizeHint.textContent = getLimit() ? `${count} von ${getLimit()} Produkten ausgewählt` : 'Wähle zuerst deine Boxgröße.';
      if (summary) summary.textContent = selected.length ? selected.join(' · ') : 'Noch keine Produkte ausgewählt.';
      if (bodyField) bodyField.value = 'Anfrage zur Änderung einer Hausbox\n\nBestellnummer: ' + (qs('#hb-change-order', changeForm)?.value || '') + '\nName: ' + (qs('#hb-change-name', changeForm)?.value || '') + '\nE-Mail: ' + (qs('#hb-change-email', changeForm)?.value || '') + '\nBoxgröße: ' + (sizeSelect?.selectedOptions?.[0]?.textContent || 'Nicht ausgewählt') + '\n\nGewünschte Produktauswahl:\n' + (selected.length ? selected.map(x => '• ' + x).join('\n') : 'Keine Produkte ausgewählt') + '\n\nZusätzliche Hinweise: ' + (qs('#hb-change-message', changeForm)?.value || 'Keine');
    };
    const filterCards = () => {
      // Keep the customer's chosen category stable while quantities change.
      // Product selection must never jump automatically to that product's category.
      const term = (search?.value || '').trim().toLocaleLowerCase('de-DE');
      let visible = 0;
      let visibleSelected = 0;
      cards.forEach(card => {
        const qty = Number(card.dataset.changeQty || 0);
        // Wie auf der Hauptseite: eine Suche gilt immer für alle Kategorien.
        const categoryMatch = term ? true : (activeCategory === 'all' ? true : (activeCategory === 'selected' ? qty > 0 : card.dataset.changeCategory === activeCategory));
        const textMatch = !term || (card.dataset.changeTitle || '').toLocaleLowerCase('de-DE').includes(term);
        const show = categoryMatch && textMatch;
        card.hidden = !show;
        card.classList.toggle('is-hidden', !show);
        if (show) { visible++; if (qty > 0) visibleSelected++; }
      });
      const noResults = qs('#hb-change-no-results', changeForm);
      if (noResults) noResults.hidden = visible > 0;
      if (clear) clear.hidden = !term;
      if (searchHint) searchHint.textContent = term ? (visible ? `${visible} ${visible === 1 ? 'Produkt gefunden' : 'Produkte gefunden'} · in allen Kategorien` : 'Keine passenden Produkte gefunden. Versuch einen anderen Suchbegriff.') : 'Finde deine Produkte schnell über die Suche.';
      categoryButtons.forEach(btn => {
        const active = (btn.dataset.changeCategory || 'all') === activeCategory;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    cards.forEach(card => {
      const plus = card.querySelector('[data-change-plus]');
      const minus = card.querySelector('[data-change-minus]');
      // Handlers are delegated below so clicks keep working even if theme scripts alter card contents.

    });
    changeForm.addEventListener('click', event => {
      const plus = event.target.closest('[data-change-plus]');
      const minus = event.target.closest('[data-change-minus]');
      const remove = event.target.closest('[data-change-remove]');
      const cardTarget = event.target.closest('[data-change-product]');
      if (remove && changeForm.contains(remove)) {
        event.preventDefault();
        const card = remove.closest('[data-change-product]');
        if (card) { card.dataset.changeQty = '0'; updateSelection(); filterCards(); }
      } else if (plus && changeForm.contains(plus)) {
        event.preventDefault();
        const card = plus.closest('[data-change-product]');
        if (card) {
          const maxQty = Math.max(1, Number(card.dataset.maxQty || 2));
          if (!getLimit()) { toast('Bitte wähle zuerst deine Boxgröße.'); return; }
          if (getTotalSelected() >= getLimit()) { toast(`Deine Box ist mit ${getLimit()} Produkten voll.`); return; }
          if (Number(card.dataset.changeQty || 0) >= maxQty) { toast(`Für dieses Produkt sind maximal ${maxQty} Stück pro Box möglich.`); return; }
          card.dataset.changeQty = Number(card.dataset.changeQty || 0) + 1;
          updateSelection();
          filterCards();
        }
      } else if (minus && changeForm.contains(minus)) {
        event.preventDefault();
        const card = minus.closest('[data-change-product]');
        if (card) {
          card.dataset.changeQty = Math.max(0, Number(card.dataset.changeQty || 0) - 1);
          updateSelection();
          filterCards();
        }
      } else if (cardTarget && !event.target.closest('button, input, a, textarea, label') && changeForm.contains(cardTarget)) {
        const current = Number(cardTarget.dataset.changeQty || 0);
        const maxQty = Math.max(1, Number(cardTarget.dataset.maxQty || 2));
        if (!getLimit()) { toast('Bitte wähle zuerst deine Boxgröße.'); return; }
        if (getTotalSelected() < getLimit() && current < maxQty) cardTarget.dataset.changeQty = current + 1;
        else if (current >= maxQty) toast(`Für dieses Produkt sind maximal ${maxQty} Stück pro Box möglich.`);
        updateSelection();
        filterCards();
      }
    });
    categoryButtons.forEach(btn => btn.addEventListener('click', () => {
      activeCategory = btn.dataset.changeCategory || 'all';
      // Beim Wechsel auf eine Kategorie den Suchbegriff löschen, damit keine versteckten Filter bleiben.
      if (search) search.value = '';
      filterCards();
    }));
    search?.addEventListener('input', filterCards);
    sizeSelect?.addEventListener('change', () => { updateSelection(); filterCards(); });
    clear?.addEventListener('click', () => { if (search) { search.value = ''; search.focus(); } filterCards(); });
    ['#hb-change-order','#hb-change-name','#hb-change-email','#hb-change-message'].forEach(sel => qs(sel, changeForm)?.addEventListener('input', updateSelection));
    changeForm.addEventListener('submit', event => {
      updateSelection();
      if (!getLimit()) {
        event.preventDefault();
        window.alert('Bitte wähle zuerst deine Boxgröße aus.');
        sizeSelect?.focus();
        return;
      }
      if (getTotalSelected() !== getLimit()) {
        event.preventDefault();
        window.alert(`Bitte wähle genau ${getLimit()} Produkte aus. Aktuell sind ${getTotalSelected()} ausgewählt.`);
        return;
      }
    });
    updateSelection();
    filterCards();
  }


  const app = qs('.hb-app');
  if (!app) return;

  const tierCards = qsa('.hb-tier-card');
  const tierCarousel = qs('[data-tier-carousel]');
  const tierViewport = qs('[data-tier-viewport]');
  let activeTierIndex = 0;
  const wrapTierIndex = index => (index + tierCards.length) % tierCards.length;
  const paintTierCarousel = () => {
    if (!tierCards.length || !tierCarousel) return;
    activeTierIndex = wrapTierIndex(activeTierIndex);
    tierCards.forEach((card, index) => {
      const deltaRaw = index - activeTierIndex;
      let delta = deltaRaw;
      if (deltaRaw > tierCards.length / 2) delta -= tierCards.length;
      if (deltaRaw < -tierCards.length / 2) delta += tierCards.length;
      card.classList.toggle('is-center', delta === 0);
      card.classList.toggle('is-left', delta === -1);
      card.classList.toggle('is-right', delta === 1);
      card.classList.toggle('is-away', Math.abs(delta) > 1);
      card.setAttribute('aria-current', delta === 0 ? 'true' : 'false');
      card.style.setProperty('--carousel-delta', delta);
    });
    qsa('[data-tier-dot]', tierCarousel).forEach(dot => {
      const active = Number(dot.dataset.tierDot) === activeTierIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    const pos = qs('[data-tier-position]', tierCarousel);
    if (pos) pos.textContent = `${activeTierIndex + 1} / ${tierCards.length}`;
  };
  const moveTierCarousel = delta => {
    activeTierIndex = wrapTierIndex(activeTierIndex + delta);
    paintTierCarousel();
  };
  if (tierCards.length && tierCarousel) {
    paintTierCarousel();
    qs('[data-tier-prev]', tierCarousel)?.addEventListener('click', () => moveTierCarousel(-1));
    qs('[data-tier-next]', tierCarousel)?.addEventListener('click', () => moveTierCarousel(1));
    qsa('[data-tier-dot]', tierCarousel).forEach(dot => dot.addEventListener('click', () => {
      activeTierIndex = Number(dot.dataset.tierDot);
      paintTierCarousel();
    }));
    let touchStartX = 0, touchStartY = 0, touchMoved = false;
    tierViewport?.addEventListener('touchstart', event => {
      const touch = event.changedTouches[0]; touchStartX = touch.clientX; touchStartY = touch.clientY; touchMoved = false;
    }, {passive:true});
    tierViewport?.addEventListener('touchmove', event => {
      const touch = event.changedTouches[0];
      if (Math.abs(touch.clientX - touchStartX) > 12 && Math.abs(touch.clientX - touchStartX) > Math.abs(touch.clientY - touchStartY)) touchMoved = true;
    }, {passive:true});
    tierViewport?.addEventListener('touchend', event => {
      const dx = event.changedTouches[0].clientX - touchStartX;
      if (touchMoved && Math.abs(dx) > 45) moveTierCarousel(dx < 0 ? 1 : -1);
    }, {passive:true});
    let pointerX = null;
    tierViewport?.addEventListener('pointerdown', event => { if (event.pointerType === 'mouse') pointerX = event.clientX; });
    tierViewport?.addEventListener('pointerup', event => {
      if (pointerX === null) return;
      const dx = event.clientX - pointerX; pointerX = null;
      if (Math.abs(dx) > 70) moveTierCarousel(dx < 0 ? 1 : -1);
    });
  }
  const productCards = qsa('.hb-product-v4');
  const countEl = qs('#hb-selected-count');
  const limitEl = qs('#hb-limit');
  const reviewBtn = qs('#hb-review');
  const readyText = qs('#hb-ready-text');
  const builder = qs('#hb-builder');
  const reviewPanel = qs('#hb-review-panel');
  const summarySize = qs('#hb-summary-size');
  const summaryCount = qs('#hb-summary-count');
  const summaryProducts = qs('#hb-summary-products');
  const priceEl = qs('#hb-price');
  const once = qs('#hb-once');
  const subscribe = qs('#hb-subscribe');
  const dataEl = qs('#hb-product-data');
  const summaryBoxArt = qs('#hb-summary-box-art');
  const selectedTabCount = qs('#hb-selected-tab-count');
  const selectedEmpty = qs('#hb-selected-empty');
  const toast = msg => { const t=qs('#hb-toast'); if(!t)return; t.textContent=msg; t.classList.add('is-on'); clearTimeout(window.__hbToast); window.__hbToast=setTimeout(()=>t.classList.remove('is-on'),2400); };

  let productData = null;
  try { productData = dataEl ? JSON.parse(dataEl.textContent) : null; } catch(e) {}
  let selectedCard = null;
  let limit = 0;
  let quantities = {};
  let chosenTierName = '';
  let chosenVariantId = null;
  let chosenPrice = '–';
  let chosenTierKey = 'basic';
  const stateStore = (() => { try { return window.sessionStorage; } catch(e) { return null; } })();
  const readBuilderState = () => { try { return stateStore ? JSON.parse(stateStore.getItem('hb-builder-view') || '{}') : {}; } catch(e) { return {}; } };
  const savedBuilderView = readBuilderState();
  let currentCategory = ['all','selected','bad','kueche','haushalt','waesche'].includes(savedBuilderView.category) ? savedBuilderView.category : 'all';
  let searchTerm = typeof savedBuilderView.search === 'string' ? savedBuilderView.search : '';
  const saveBuilderView = () => { try { stateStore?.setItem('hb-builder-view', JSON.stringify({category:currentCategory, search:searchTerm})); } catch(e) {} };
  const searchInput = qs('#hb-product-search');
  const clearSearch = qs('#hb-clear-search');
  const searchHint = qs('#hb-search-hint');

  const totalQty = () => Object.values(quantities).reduce((a,b)=>a+Number(b||0),0);
  const money = value => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency: window.Hausbox?.currency || 'EUR'}).format(Number(value)/100); } catch(e) { return '–'; }
  };
  const escapeHtml = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const renderProducts = () => {
    // Persist the current view on every redraw, including product selection.
    // Product selection changes quantities only; it must never switch categories.
    saveBuilderView();
    qsa('.hb-category-tabs [data-category]').forEach(tab => {
      const active = (tab.dataset.category || 'all') === currentCategory;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    const total = totalQty();
    if (countEl) countEl.textContent = total;
    if (limitEl) limitEl.textContent = limit || 0;
    if (selectedTabCount) selectedTabCount.textContent = total;
    let visibleSelected = 0;
    productCards.forEach(card => {
      const id = card.dataset.variantId || card.dataset.productId;
      const qty = Number(quantities[id] || 0);
      // Eine aktive Suche ist immer global und ignoriert die gerade gewählte Kategorie.
      // Ohne Suchbegriff gelten weiterhin die Kategorie-Filter einschließlich „Ausgewählt“.
      const categoryMatch = searchTerm
        ? true
        : (currentCategory === 'all' ? true : (currentCategory === 'selected' ? qty > 0 : card.dataset.category === currentCategory));
      const searchable = `${card.dataset.product || ''} ${qs('.hb-product-copy small', card)?.textContent || ''}`.toLocaleLowerCase('de-DE');
      const searchMatch = !searchTerm || searchable.includes(searchTerm);
      const visible = categoryMatch && searchMatch;
      if (visible && qty > 0) visibleSelected += 1;
      card.classList.toggle('is-hidden', !visible);
      card.dataset.qty = qty;
      qs('[data-qty-value]',card).textContent = qty;
      card.classList.toggle('is-selected', qty > 0);
      const removeSelection = qs('[data-remove-selection]', card);
      if (removeSelection) removeSelection.hidden = qty <= 0;
      const minus=qs('[data-qty-minus]',card), plus=qs('[data-qty-plus]',card);
      if(minus) minus.disabled = qty<=0;
      if(plus) plus.disabled = !chosenTierName || total>=limit || qty>=Math.max(1,Number(card.dataset.maxQty||2));
    });
    if (selectedEmpty) selectedEmpty.hidden = !(currentCategory === 'selected' && visibleSelected === 0 && !searchTerm);
    const visibleCount = productCards.filter(card => !card.classList.contains('is-hidden')).length;
    if (searchHint) {
      searchHint.textContent = searchTerm
        ? (visibleCount ? `${visibleCount} ${visibleCount === 1 ? 'Produkt gefunden' : 'Produkte gefunden'} · in allen Kategorien` : 'Keine passenden Produkte gefunden. Versuch einen anderen Suchbegriff.')
        : 'Finde deine Produkte schnell über die Suche.';
    }
    if (clearSearch) clearSearch.hidden = !searchTerm;
    const ready = Boolean(chosenTierName && total===limit && chosenVariantId);
    if(reviewBtn) reviewBtn.disabled=!ready;
    if(readyText) readyText.textContent=!chosenTierName?'Wähle zuerst eine Box.':(!chosenVariantId?'Box-Produkt verbinden.':(ready?'✓ Box vollständig':`${limit-total} ${limit-total===1?'Produkt fehlt':'Produkte fehlen'}`));
  };
  const resetQuantities = () => { quantities={}; productCards.forEach(c=>c.dataset.qty='0'); renderProducts(); };
  const scrollToBuilder = () => builder?.scrollIntoView({behavior:'smooth',block:'start'});

  const selectTier = (card) => {
    tierCards.forEach(c=>c.classList.remove('is-selected'));
    card.classList.add('is-selected');
    selectedCard=card; chosenTierKey=card.dataset.tier||'basic'; chosenTierName=card.dataset.tierName||''; limit=Number(card.dataset.limit||0); chosenVariantId=card.dataset.variantId||null; chosenPrice=card.dataset.price||'–';
    // Die zuletzt gewählte Kategorie bleibt beim Boxwechsel erhalten.
    qsa('.hb-category-tabs [data-category]').forEach(x=>x.classList.toggle('is-active', x.dataset.category===currentCategory));
    resetQuantities();
    const heading=qs('#hb-builder-heading'); if(heading) heading.textContent=`${chosenTierName} zusammenstellen`;
    const sub=qs('#hb-builder-sub'); if(sub) sub.textContent=`Wähle genau ${limit} Produkte. Ein Produkt darf mehrfach in die Box.`;
    const selected=qs('.hb-selected-tier'); if(selected) selected.textContent=chosenTierName||'Box';
    if(reviewPanel) reviewPanel.hidden=true;
    scrollToBuilder();
  };


  // iPhone/mobile fallback: catches taps even if a child element or browser overlay interferes with the button listener.
  document.addEventListener('click', (event) => {
    const card=event.target.closest?.('.hb-tier-card');
    if(!card || !app.contains(card)) return;
    const index = tierCards.indexOf(card);
    if (index !== activeTierIndex) {
      activeTierIndex = index;
      paintTierCarousel();
      return;
    }
    selectTier(card);
  });


  productCards.forEach(card => {
    const add = () => {
      if(!chosenTierName){toast('Bitte zuerst eine Box auswählen.');return;}
      if(totalQty()>=limit){toast(`Deine ${chosenTierName} ist mit ${limit} Produkten voll.`);return;}
      const id=card.dataset.variantId||card.dataset.productId;
      const current=Number(quantities[id]||0);
      const maxQty=Math.max(1,Number(card.dataset.maxQty||2));
      if(current>=maxQty){toast(`Für dieses Produkt sind maximal ${maxQty} Stück pro Box möglich.`);return;}
      quantities[id]=current+1; renderProducts();
    };
    card.addEventListener('click', e => { if(!e.target.closest('button')) { e.preventDefault(); add(); } });
    qs('[data-qty-plus]',card)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();add();});
    qs('[data-qty-minus]',card)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const id=card.dataset.variantId||card.dataset.productId;const n=Math.max(0,Number(quantities[id]||0)-1);if(n)quantities[id]=n;else delete quantities[id];renderProducts();});
    qs('[data-remove-selection]',card)?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const id=card.dataset.variantId||card.dataset.productId;delete quantities[id];renderProducts();toast('Produkt aus der Auswahl entfernt.');});
  });

  if (searchInput && savedBuilderView.search) searchInput.value = savedBuilderView.search;
  searchInput?.addEventListener('input', () => {
    searchTerm = searchInput.value.trim().toLocaleLowerCase('de-DE');
    saveBuilderView();
    renderProducts();
  });
  clearSearch?.addEventListener('click', () => {
    if (searchInput) { searchInput.value = ''; searchInput.focus(); }
    searchTerm = '';
    saveBuilderView();
    renderProducts();
  });

  qsa('.hb-category-tabs [data-category]').forEach(tab=>tab.addEventListener('click',(event)=>{
    event.preventDefault();
    event.stopPropagation();
    currentCategory = tab.dataset.category || 'all';
    // Kategorieauswahl setzt eine vorherige globale Suche zurück.
    searchTerm = '';
    if (searchInput) searchInput.value = '';
    saveBuilderView();
    renderProducts();
  }));
  qs('#hb-change-box')?.addEventListener('click',()=>qs('.hb-box-choice')?.scrollIntoView({behavior:'smooth',block:'start'}));
  qs('#hb-edit-products')?.addEventListener('click',()=>{if(reviewPanel)reviewPanel.hidden=true;scrollToBuilder();});

  const renderSummary=()=>{
    summarySize.textContent=chosenTierName; summaryCount.textContent=`${totalQty()} von ${limit} Produkten`; priceEl.textContent=chosenPrice;
    if(summaryBoxArt && selectedCard){ const img=selectedCard.querySelector('.hb-box-image, .hb-box-illustration img'); if(img){summaryBoxArt.innerHTML=`<img src="${img.currentSrc||img.src}" alt="" width="260" height="260">`; } }
    const items=Object.entries(quantities).filter(([,q])=>Number(q)>0).map(([id,q])=>{const card=productCards.find(c=>(c.dataset.variantId||c.dataset.productId)===id);return card?{name:card.dataset.product,qty:q,variant:id}:null;}).filter(Boolean);
    summaryProducts.innerHTML=items.length?items.map(x=>`<span>✓ ${escapeHtml(x.name)} × ${x.qty}</span>`).join(''):'<span>Noch keine Produkte</span>';
  };
  reviewBtn?.addEventListener('click',()=>{if(!chosenTierName||totalQty()!==limit||!chosenVariantId){toast(`Bitte genau ${limit||0} Produkte auswählen.`);return;}renderSummary();reviewPanel.hidden=false;reviewPanel.scrollIntoView({behavior:'smooth',block:'start'});});

  const getBoxVariant=()=> productData?.variants?.find(v=>String(v.id)===String(chosenVariantId)) || null;
  async function addToCart(subscription=false){
    if(!chosenTierName||totalQty()!==limit||!chosenVariantId){toast(`Bitte genau ${limit||0} Produkte auswählen.`);return;}
    const variant=getBoxVariant(); if(!variant){toast('Bitte im Theme-Editor ein gültiges Hausbox-Produkt verbinden.');return;}
    if(!variant.available){toast('Diese Box-Variante ist aktuell nicht verfügbar.');return;}
    let sellingPlan=null;
    if(subscription){sellingPlan=productData?.sellingPlans?.[0]?.id;if(!sellingPlan){toast('Für die Monatslieferung bitte einen Shopify-Abo-Plan am Box-Produkt anlegen.');return;}}
    const items=Object.entries(quantities).filter(([,q])=>Number(q)>0).map(([id,q])=>{const card=productCards.find(c=>(c.dataset.variantId||c.dataset.productId)===id);return card?`${card.dataset.product} × ${q}`:id;});
    const properties={'Box':chosenTierName,'Box Variante':variant.title,'Anzahl Produkte':String(totalQty()),'Box Inhalt':items.join(', ')};
    items.forEach((item, index) => { properties[`Produkt ${index + 1}`] = item; });
    const payload={items:[{id:variant.id,quantity:1,properties}]}; if(sellingPlan)payload.items[0].selling_plan=sellingPlan;
    try{
      once&&(once.disabled=true);subscribe&&(subscribe.disabled=true);
      const r=await fetch(`${window.Hausbox.routes.cartAdd}.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      if(!r.ok) throw new Error('cart');
      const cart=await fetch('/cart.js').then(x=>x.json());const c=qs('#hb-cart-count');if(c)c.textContent=cart.item_count;
      toast(subscription?'Monatsbox wurde hinzugefügt.':'Box wurde hinzugefügt.');setTimeout(()=>location.href=window.Hausbox.routes.cart,450);
    }catch(e){toast('Beim Hinzufügen ist etwas schiefgelaufen.');}
    finally{once&&(once.disabled=false);subscribe&&(subscribe.disabled=false);}
  }
  once?.addEventListener('click',()=>addToCart(false)); subscribe?.addEventListener('click',()=>addToCart(true));
  renderProducts();

})();
